import { Loader, Box } from 'braid-design-system';
import React, { useState } from 'react';

import { ListingStatus } from 'src/generated/graphql';
import type {
  ClientListingForListingsTab,
  ListingProductForListingsTab,
} from 'src/types/graphql-derived';
import {
  getEmailBoostProduct,
  getSearchBoostProduct,
  getIsListingLus,
  isFreemium,
} from 'src/utils/listingProducts';

import { PostedView } from './components/Action/PostedView';
import { UnpostedView } from './components/Action/UnpostedView';

interface Props {
  listing: ClientListingForListingsTab;
  postFunction: () => void;
  expireFunction: () => void;
  isProcessing: boolean;
  listingProducts: ListingProductForListingsTab[];
}

const Actions = ({
  listing,
  postFunction,
  expireFunction,
  isProcessing,
  listingProducts,
}: Props) => {
  const isPosted =
    listing.status === ListingStatus.Active ||
    listing.status === ListingStatus.Pending;
  const [doingRedirect, setDoingRedirect] = useState(false);
  const handleRedirectClick = () => setDoingRedirect(true);

  if (isProcessing || doingRedirect) {
    return (
      <Box paddingY="medium" display="flex" justifyContent="center">
        <Loader />
      </Box>
    );
  }

  // Draft ads will not have a "productCode"
  if (listing.legacyProductCode && isPosted) {
    return (
      <PostedView
        listing={listing}
        isLus={getIsListingLus(listingProducts, listing)}
        isFreemium={isFreemium(listingProducts, listing)}
        searchBoostProduct={getSearchBoostProduct(listingProducts, listing)}
        emailBoostProduct={getEmailBoostProduct(listingProducts, listing)}
        onEditClick={handleRedirectClick}
        onExpireClick={expireFunction}
        onViewClick={handleRedirectClick}
      />
    );
  }

  return (
    <UnpostedView
      listing={listing}
      onEditClick={handleRedirectClick}
      onPreviewClick={handleRedirectClick}
      onPaidPostClick={postFunction}
      onUnpaidPostClick={handleRedirectClick}
    />
  );
};

export default Actions;
